<script setup lang="ts">
  import navigate from '@utils/navigate'
  import { IconButton, Shimmer, Typography } from '@components/index'
  import { fetchBreadcrumbs } from '@server/index'
  import { IBreadcrumbsProps, IBreadcrumbsData } from '@/types/index'
  import { EMenuType } from '@enums/EMenuType'

  const props = defineProps<IBreadcrumbsProps>()
  const isFavorite = ref<boolean>(props.isFavorite ?? false)
  const favoriteIcon = ref<string>(isFavorite.value ? 'bookmark-heart-fill' : 'bookmark-plus-fill')
  const breadcrumbsList = ref<IBreadcrumbsData[]>([])

  const handleClickBack = () => {
    if (breadcrumbsList.value.length > 1) {
      const bread = breadcrumbsList.value[breadcrumbsList.value.length - 2]
      if (bread.title === 'MENU') {
        navigate.backTo(`/`)
      } else if (bread.type === EMenuType.NAVIGATION) {
        navigate.backTo(`/nodes/${bread.id}`)
      }
    }
  }

  const handleClickHome = () => {
    navigate.backTo('/')
  }

  const handleClickFavorite = () => {
    isFavorite.value = !isFavorite.value
    favoriteIcon.value = isFavorite.value ? 'bookmark-heart-fill' : 'bookmark-plus-fill'
  }

  const handleClickBackTo = (bread: IBreadcrumbsData) => {
    if (bread.title === 'MENU') {
      navigate.backTo(`/`)
    } else if (bread.type === 'NAVIGATION') {
      navigate.backTo(`/nodes/${bread.id}`)
    } else {
      navigate.backTo(`/details/${bread.id}`)
    }
  }

  onBeforeMount(() => {
    const result = fetchBreadcrumbs(props.id)

    watchEffect(() => {
      breadcrumbsList.value = result.value
    })
  })
</script>

<template>
  <div class="d-flex flex-column">
    <div class="d-flex">
      <div class="d-flex align-items-center">
        <IconButton
          id="back"
          icon="arrow-left-square-fill"
          size="25"
          :on-click="handleClickBack"
        />
        <IconButton
          id="home"
          icon="house-door-fill"
          :on-click="handleClickHome"
          class="mx-4"
        />
      </div>
      <div
        v-if="props.showFavorite && false"
        class="ms-auto"
      >
        <IconButton
          id="favorite"
          :icon="favoriteIcon"
          :on-click="handleClickFavorite"
        />
      </div>
    </div>
    <div
      v-if="breadcrumbsList.length > 0"
      class="d-flex mb-3"
    >
      <Typography variant="breadcrumb">
        <template
          v-for="(bread, index) in breadcrumbsList"
          :key="index"
        >
          <span
            v-if="index > 0"
            class="mx-0"
          >
            /
          </span>
          <button
            class="px-0"
            :class="[index === breadcrumbsList.length - 1 ? 'current-link' : 'link']"
            @click="handleClickBackTo(bread)"
          >
            {{ bread.title }}
          </button>
        </template>
      </Typography>
    </div>
    <div v-else>
      <Shimmer class="d-flex mb-2 shimmer" />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .link {
    background: none;
    border: none;
    color: #8b9198;
    cursor: pointer;
    text-align: left;
  }

  .current-link {
    background: none;
    border: none;
    color: #04d200;
    text-align: left;
  }

  .shimmer {
    height: 30px;
  }
</style>
